// extracted by mini-css-extract-plugin
module.exports = {"container":"StatisticBox-container_94ea5dd8","normal":"StatisticBox-normal_5250a84c","sup":"StatisticBox-sup_4bd0a486"};